import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled", "title"]
const _hoisted_2 = { class: "flex flex-wrap items-center gap-x-6 gap-y-3" }
const _hoisted_3 = { class: "flex min-w-0 flex-1 items-center gap-3" }
const _hoisted_4 = { class: "shrink-0 font-semibold" }
const _hoisted_5 = { class: "ml-auto flex items-center gap-2" }
const _hoisted_6 = { class: "text-xs font-medium text-gray-400" }
const _hoisted_7 = { class: "inline-flex rounded-lg border border-gray-200 bg-white p-0.5" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-xs font-medium text-gray-400" }
const _hoisted_11 = { class: "inline-flex rounded-lg border border-gray-200 bg-white p-0.5" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-center px-4 py-16"
}
const _hoisted_14 = {
  key: "content",
  class: "mt-8 overflow-x-auto"
}
const _hoisted_15 = { class: "flex min-w-[1064px] flex-col" }
const _hoisted_16 = { class: "mb-2 flex items-baseline gap-2 px-3" }
const _hoisted_17 = { class: "text-[14.5px] font-extrabold text-gray-900" }
const _hoisted_18 = { class: "text-xs font-medium text-gray-400" }
const _hoisted_19 = { class: "mb-2.5 flex items-center gap-5 px-3 text-[11px] text-gray-400" }
const _hoisted_20 = { class: "flex items-baseline gap-1.5" }
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "flex items-baseline gap-1.5" }
const _hoisted_23 = { class: "font-medium" }
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "section-grid-row mb-1.5 text-[10px] font-bold uppercase tracking-[0.5px] text-gray-400" }
const _hoisted_26 = { class: "px-3" }
const _hoisted_27 = { class: "px-3" }
const _hoisted_28 = { class: "px-3" }
const _hoisted_29 = { class: "px-3" }
const _hoisted_30 = { class: "px-3" }
const _hoisted_31 = { class: "px-3" }
const _hoisted_32 = { class: "px-3" }
const _hoisted_33 = { class: "px-3" }
const _hoisted_34 = { class: "flex flex-col gap-[6px]" }
const _hoisted_35 = ["title", "aria-label", "onClick"]
const _hoisted_36 = ["title"]
const _hoisted_37 = {
  key: 0,
  class: "text-[11.5px] font-normal text-gray-400"
}
const _hoisted_38 = {
  key: 1,
  class: "flex min-w-0 items-center gap-2 px-3 py-[9px]"
}
const _hoisted_39 = ["title"]
const _hoisted_40 = {
  class: "flex items-center px-3 py-[9px]",
  style: {"grid-column":"2 / 4"}
}
const _hoisted_41 = ["title", "onClick"]
const _hoisted_42 = {
  class: "px-3 py-[9px] tabular-nums font-semibold text-gray-400",
  style: {"grid-column":"4"}
}
const _hoisted_43 = {
  class: "flex items-center px-3 py-[9px]",
  style: {"grid-column":"5 / 9"}
}
const _hoisted_44 = { class: "text-xs italic text-gray-400" }
const _hoisted_45 = { class: "px-3 py-[9px]" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 1,
  class: "inline-flex items-center whitespace-nowrap rounded-full bg-sky-100 px-2.5 py-0.5 text-[11px] font-bold text-cyan-700"
}
const _hoisted_48 = {
  key: 2,
  class: "text-gray-300"
}
const _hoisted_49 = { class: "tabular-nums" }
const _hoisted_50 = { class: "px-3 py-[9px] tabular-nums font-semibold text-gray-700" }
const _hoisted_51 = { class: "tabular-nums" }
const _hoisted_52 = ["title", "onClick"]
const _hoisted_53 = {
  key: 1,
  class: "text-[16px] font-extrabold leading-none text-gray-300"
}
const _hoisted_54 = {
  key: 1,
  class: "block px-3 py-[9px] text-[16px] font-extrabold leading-none text-gray-300"
}
const _hoisted_55 = { class: "tabular-nums" }
const _hoisted_56 = { class: "text-[16px] font-extrabold leading-none text-gray-900" }
const _hoisted_57 = { class: "text-[11px] text-gray-400" }
const _hoisted_58 = ["title"]
const _hoisted_59 = ["title", "onClick"]
const _hoisted_60 = ["title"]
const _hoisted_61 = {
  class: "flex items-center justify-center py-[9px] pr-2",
  style: {"grid-column":"9"}
}
const _hoisted_62 = ["title", "onClick"]
const _hoisted_63 = {
  key: "empty",
  class: "flex items-center justify-center px-4 py-16"
}
const _hoisted_64 = { class: "text-center text-gray-500" }

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { differenceInCalendarDays, format, parseISO, subMonths } from 'date-fns';
import ActionModal from '@/components/common/actionModal/ActionModal.vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import Spinner from '@/components/ui/Spinner.vue';
import { store } from '@/plugins/store';
import { ActionType } from '@/plugins/store/actions';
import { useSectionLiveKpis, useBarnLiveKpis, queryKeys as activeGroupsQueryKeys } from '@/plugins/store/actions/queries/active-groups';
import { useBarnProductionGroups, useProductionGroupTimeline, type ProductionGroupTimelineRequest } from '@/plugins/store/actions/queries/production-groups';
import { PigType, type Section, type ProductionGroup, type ProductionGroupBarnResponse } from '@/types';
import { AlertTriangle, Ban, ChevronRight, Droplets, LineChart, PlayCircle, RefreshCw, WifiOff } from 'lucide-vue-next';
import SectionDetailOverlay from './SectionDetailOverlay.vue';
import AlarmHandleModal from './AlarmHandleModal.vue';
import MortalityDetailModal from './MortalityDetailModal.vue';
import WaterDetailModal from './WaterDetailModal.vue';
import WeightDetailModal from './WeightDetailModal.vue';
import { indexColourClass, INDEX_COLOUR_RED, INDEX_COLOUR_GREEN, INDEX_COLOUR_NEUTRAL } from './indexColour';
import { ALARM_CHIP_CLASS } from './alarmChipStyle';
import ManageProductionGroupModal from '../production-groups/ManageProductionGroupModal.vue';
import ManageObjectivesModal from '@/components/common/objectives/ManageObjectivesModal.vue';
import { formatPigsToTarget, pigsToTargetColourClass } from '@/views/dashboard/overview/objectives/objectiveDisplay';
import SensorGatedKpiCell from './SensorGatedKpiCell.vue';
import DegradedCameraMarker from './DegradedCameraMarker.vue';
import IndexGaugeBar from './IndexGaugeBar.vue';
import FarmChipPicker from './FarmChipPicker.vue';
import { mortalityAtOrAboveTargetForView, mortalityPercentForView, mortalityPigsToTargetForView, type MortalityView, type SectionRow } from './sectionRow';
import { DEFAULT_SORT_KEY, sortAndGroupSectionsByFarm, type SectionSortKey } from './sortSections';
import { useAlarmModal } from '@/composables/useAlarmModal';
import { useSectionRows } from '@/composables/useSectionRows';

const placeholder = '—';

const COMPARISON_HISTORY_MONTHS = 12;

// The open Section's Production Group history, on a window of its own rather than read off the Barn
// response that resolved the row.
//
// The Barn response cannot answer this question. It is windowed by the app-global period picker,
// which this page does not carry - so its window is whatever page the reader came from last set. The
// comparison dropdown offers the Production Group *preceding* the one on screen, and a preceding
// period ends on or before the current one starts, so it lies outside any window that starts at or
// after that start. Whether a Section's predecessor is reachable would come down to where the reader
// had been.
//
// Anchored to the displayed Production Group's start and not to today, because that is what the
// candidate rule measures against: a Section far into a long cycle still has to reach back past its
// predecessor, and a window hung off today would shorten as the cycle ran on.

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const sitesAreLoaded = computed(() => store.state.sitesAreLoaded);
// getSelectedPeriodByDate (plain from/to yyyy-MM-dd), not getSelectedPeriod - matches the query
// string useBarnProductionGroups forwards to GetProductionGroups.
const selectedPeriod = computed(() => store.getters.getSelectedPeriodByDate);
const isWeaners = computed(() => store.state.pigType === PigType.Weaners);

// The all-sections data source (Module C): every physical Section in the selected barns. Fetch it on a
// fresh session if it has not been loaded yet, and gate rendering on it being available.
const sectionsAreLoaded = computed(() => store.state.sections !== null);
onMounted(() => {
    if (store.state.sections === null) {
        store.dispatch(ActionType.GetSections, {});
    }
});

// Page-local farm picker: operates over the app's global farm scope (the globally selected farms).
const scopedFarms = computed(() => store.state.farms.filter((farm) => store.state.selectedFarmIds.includes(farm.farm_id)));

// The valid farm set for the chip picker: farms in global scope that have at least one barn of the
// current pig type. Recomputes when the global pig type toggle flips, so chips for farms with no
// barns of the new type disappear automatically.
const validFarms = computed(() =>
    scopedFarms.value.filter((farm) =>
        store.state.barns.some((barn) => barn.farm_id === farm.farm_id && barn.is_weaners === isWeaners.value)
    )
);

// Selected farm ids (v-model of FarmChipPicker below), which owns sorting, the row-fits-on-one-line
// measurement and the "+N" overflow popover.
const selectedFarmIds = ref<number[]>([]);

// Sort control state (Module B). Defaults to Alder (youngest → oldest).
const sortOptions: SectionSortKey[] = ['age', 'attention', 'section'];
const sortKey = ref<SectionSortKey>(DEFAULT_SORT_KEY);

// Page-level Dynamic Mortality view toggle. Applies to the whole table at once —
// there is no per-section switching. Defaults to cumulative mortality since Production Group start.
const mortalityViewOptions: MortalityView[] = ['rolling', 'cumulative'];
const mortalityView = ref<MortalityView>('cumulative');

// Overlay state: which Section is open is the URL's business, not this component's. The route
// carries the id (ActiveGroupsDetail), so the overlay survives a reload, can be linked to, and
// closes with the back button. The row behind that id is resolved further down, independently
// of the grid's own filters.
const openSectionId = computed(() => {
    const raw = route.params.sectionId;
    return typeof raw === 'string' ? Number(raw) : null;
});

// Mortality detail modal state: the row whose Døde cell was clicked (null = closed).
const mortalityDetailSection = ref<SectionRow | null>(null);

// Targets modal (ManageObjectivesModal, shared with the Objectives page) - opened from inside the
// mortality detail modal's own "Edit target" button, pre-focused on the clicked Section's Farm.
// `isWeaner` passes straight through from this page's own pig-type filter (see isWeaners above) -
// same global store value the Objectives page's own instance reads, so no separate lookup is needed.
const targetsModal = ref<InstanceType<typeof ManageObjectivesModal> | null>(null);
// The Section the target-edit affordance was opened for - captured separately from
// mortalityDetailSection (cleared below before the Targets modal opens, so the two never stack) so
// onTargetSaved still knows which Section's live KPI to refresh once the save lands.
const targetEditSection = ref<SectionRow | null>(null);

// Same z-index hand-off as the alarm flow above: the Targets modal and the mortality modal would
// otherwise paint at conflicting stacking contexts, so the mortality modal closes first.
function onEditTargetFromMortalityDetail(section: SectionRow): void {
    mortalityDetailSection.value = null;
    targetEditSection.value = section;
    targetsModal.value?.openForFarm(section.farmId);
}

// "Setting it, should trigger a re-retrieval of the data, so the mortality figures update on the
// section in question" (ticket text) - refreshes only targetEditSection's own live KPI (see
// targetSavedSectionIds/refetchTargetSavedLiveKpi above), not the whole visible batch.
async function onTargetSaved(): Promise<void> {
    const section = targetEditSection.value;
    if (!section) return;
    targetSavedSectionIds.value = [section.id];
    await refetchTargetSavedLiveKpi();
}

// Water detail modal state: the row whose Vand cell was clicked (null = closed).
const waterDetailSection = ref<SectionRow | null>(null);

// Weight detail modal state: the row whose Vægt/Tilvækst/Vækstindeks cell was clicked (null = closed).
const weightDetailSection = ref<SectionRow | null>(null);

// Manage Production Group modal state. `manageRow` is the row whose manage button was clicked (drives
// create vs edit mode via its `productionGroupId`); `manageProductionGroup` is the active Production Group for that
// row (edit mode supplies its existing name + dates).
const isManageModalOpen = ref(false);
const manageRow = ref<SectionRow | null>(null);
const manageProductionGroup = ref<ProductionGroup | null>(null);

// Every query this page caches per-Section that a save/recompute in the modal can change: live KPIs,
// the barn KPI rollup, and the three detail-chart series. Passed to the modal so it can invalidate
// them without needing to know Active groups' own cache shape.
const manageModalInvalidateQueryKeyRoots = [
    activeGroupsQueryKeys.getSectionLiveKpisRoot,
    activeGroupsQueryKeys.getBarnLiveKpisRoot,
    activeGroupsQueryKeys.getPigTallySeriesRoot,
    activeGroupsQueryKeys.getWaterNormSeriesRoot,
    activeGroupsQueryKeys.getWeightSeriesRoot,
];

// Alarm modal state and orchestration (extracted to composable).
const {
    alarmActionState,
    alarmStepConfig,
    alarmActionHeader,
    alarmListModalOpen,
    alarmListAlarms,
    isLoadingAlarmForm,
    loadAndOpenAlarm,
    openAlarm,
    onAlarmFormClosing,
} = useAlarmModal();

// Pig-type toggle always resets to all valid farms - a farm with barns of both types stays in
// `validFarms` across the flip, so filtering the old selection against it would silently carry
// the selection over instead of resetting it for the new type.
watch(isWeaners, () => {
    selectedFarmIds.value = validFarms.value.map((farm) => farm.farm_id);
});

// Default to all valid farms, and keep the selection valid as the global farm scope changes. Drop
// selected farms that fall out of scope; if that empties the selection, re-default to all valid
// farms. Deselecting a chip by hand leaves the (possibly empty) selection alone.
watch(
    scopedFarms,
    () => {
        const ids = validFarms.value.map((farm) => farm.farm_id);
        const valid = selectedFarmIds.value.filter((id) => ids.includes(id));
        selectedFarmIds.value = valid.length ? valid : ids;
    },
    { immediate: true }
);

// Close a stale modal whenever the farm selection changes, so its snapshot never lingers. The
// detail overlay is deliberately not closed here any more: it is the route's, and a link to a
// Section has to open it whatever the farm chips happen to be filtered to.
watch(selectedFarmIds, () => {
    mortalityDetailSection.value = null;
    waterDetailSection.value = null;
    weightDetailSection.value = null;
});

const selectedFarms = computed(() => validFarms.value.filter((farm) => selectedFarmIds.value.includes(farm.farm_id)));

// Lookups to map production-group barn entries back to their Farm for the Farm → Barn grouping.
const farmsById = computed(() => new Map(store.state.farms.map((farm) => [farm.farm_id, farm])));
const barnsById = computed(() => new Map(store.state.barns.map((barn) => [barn.barn_id, barn])));

// Barns across all selected farms, filtered by the global PigType (animal group).
const farmBarns = computed(() =>
    store.state.barns.filter((barn) => selectedFarmIds.value.includes(barn.farm_id) && barn.is_weaners === isWeaners.value)
);

const barnIds = computed(() => farmBarns.value.map((barn) => barn.barn_id));
const isQueryEnabled = computed(() => barnIds.value.length > 0);

const { data: productionGroupBarns, isLoading: isProductionGroupsLoading } = useBarnProductionGroups({ barnIds, selectedPeriod }, { enabled: isQueryEnabled });

// All physical Sections in the selected barns (Module C, pass 1 source). `farmBarns`/`barnIds` already
// filter by the selected farms and the global pig type, so the barn-id membership test carries both.
// Declared ahead of the live-KPI query below because that query is addressed by section and takes
// its section ids from here.
const physicalSections = computed<Section[]>(() => {
    if (!store.state.sections) {
        return [];
    }
    const barnIdSet = new Set(barnIds.value);
    return store.state.sections.filter((section) => barnIdSet.has(section.barn_id));
});

// Single batch query for every section on the page, addressed by section
// rather than by barn. The section list is already client-side and already scoped to the selected
// farms and the active PigType, so no extra request is needed to discover the ids and the server
// resolves nothing from barns. Stays a computed so the query re-runs when the selection changes.
const sectionIds = computed(() => physicalSections.value.map((section) => section.id));
const { data: liveKpisData, isLoading: isLiveKpisLoading, isFetching: isLiveKpisFetching, refetch: refetchLiveKpis } = useSectionLiveKpis(sectionIds);
const liveKpis = computed(() => liveKpisData.value ?? []);

// Barn aggregate KPIs: pig count + dead (last 7 days) per barn.
const { data: barnKpisData, isFetching: isBarnKpisFetching, refetch: refetchBarnKpis } = useBarnLiveKpis(barnIds);
const barnKpiByBarnId = computed(() => new Map((barnKpisData.value ?? []).map((k) => [k.barn_id, k])));

// A single-Section KPI re-read for right after a mortality-target save (see targetsModal/onTargetSaved
// below) - its own independently-keyed query rather than a call to refetchLiveKpis(), which would
// refetch the whole visible batch. The ticket is explicit: saving updates "the section in question",
// not every row on screen - siblings self-correct on the existing 5-minute poll. Mirrors the
// linkedSectionIds/linkedLiveKpisData pattern further down for the same reason (a second,
// independently-keyed useSectionLiveKpis call over a single id).
const targetSavedSectionIds = ref<number[]>([]);
const { data: targetSavedLiveKpisData, refetch: refetchTargetSavedLiveKpi } = useSectionLiveKpis(targetSavedSectionIds);

// Merge key: the live-KPI section_id is the Section's LocationObject id, matching production-group.location_id.
// The single-Section re-read above is layered on top so its fresher figures win for that one Section,
// without touching every other row's data from the batch query.
const liveKpisBySectionId = computed(() => {
    const map = new Map(liveKpis.value.map((kpi) => [kpi.section_id, kpi]));
    for (const kpi of targetSavedLiveKpisData.value ?? []) map.set(kpi.section_id, kpi);
    return map;
});

const isLoading = computed(
    () =>
        !sitesAreLoaded.value ||
        !sectionsAreLoaded.value ||
        (isQueryEnabled.value && isProductionGroupsLoading.value) ||
        (isQueryEnabled.value && isLiveKpisLoading.value)
);

// Currently open Production Groups keyed by their Section (location_id = Section.id).
// useBarnProductionGroups is a shared query that returns all SPs within the selected date range;
// filter here to those that haven't ended yet so ended Production Groups don't appear as active rows.
function activeProductionGroupsBySectionId(barnEntries: ProductionGroupBarnResponse | undefined): Map<number, ProductionGroup> {
    const map = new Map<number, ProductionGroup>();
    for (const barnEntry of barnEntries ?? []) {
        for (const productionGroup of barnEntry.production_groups ?? []) {
            // Calendar-day comparison, not instant comparison - a Production Group ending "today"
            // must stay visible for the rest of today, not disappear the moment `new Date()`
            // ticks past midnight of its end date.
            if (!productionGroup.end || differenceInCalendarDays(parseISO(productionGroup.end), new Date()) >= 0) {
                map.set(productionGroup.location_id, productionGroup);
            }
        }
    }
    return map;
}

const productionGroupBySectionId = computed(() => activeProductionGroupsBySectionId(productionGroupBarns.value));

// Flat Section view-model list (Module C). Two-pass transformation extracted to composable.
// Each row's `attentionLevel` (Module A) is precomputed once there, rather than independently
// recomputed by card colouring and the sort/group module below.
const { sectionRows } = useSectionRows(physicalSections, productionGroupBySectionId, liveKpisBySectionId, farmsById, barnsById);

// The grid's own row for the open Section, for the ordinary case where the current filters show it.
const openSectionGridRow = computed<SectionRow | null>(() => sectionRows.value.find((row) => row.id === openSectionId.value) ?? null);

// A link can also name a Section the grid is not showing: `sectionRows` is scoped to both the pig
// type and the chosen farms, and a URL knows about neither. Such a Section is resolved here on its
// own terms - from the unfiltered Section list, plus that one Section's live KPIs and that one
// Barn's Production Groups - rather than by moving the reader's pig type and farm chips onto it. The
// overlay is a destination; opening one says nothing about what the rest of the app is filtered to.
//
// Both reads stay disabled while the grid can supply the row itself, so an ordinary open still
// costs no request of its own.
const linkedSection = computed<Section | null>(() => {
    if (openSectionId.value === null || openSectionGridRow.value !== null) return null;
    return (store.state.sections ?? []).find((section) => section.id === openSectionId.value) ?? null;
});
const linkedSectionIds = computed(() => (linkedSection.value ? [linkedSection.value.id] : []));
const linkedBarnIds = computed(() => (linkedSection.value ? [linkedSection.value.barn_id] : []));

const { data: linkedLiveKpisData, isLoading: isLinkedLiveKpisLoading } = useSectionLiveKpis(linkedSectionIds);
const linkedLiveKpisBySectionId = computed(() => new Map((linkedLiveKpisData.value ?? []).map((kpi) => [kpi.section_id, kpi])));

const linkedProductionGroupsEnabled = computed(() => linkedBarnIds.value.length > 0);
const { data: linkedProductionGroupBarns, isLoading: isLinkedProductionGroupsLoading } = useBarnProductionGroups({ barnIds: linkedBarnIds, selectedPeriod }, { enabled: linkedProductionGroupsEnabled });
const linkedProductionGroupBySectionId = computed(() => activeProductionGroupsBySectionId(linkedProductionGroupBarns.value));

// Held back until both reads have settled: a row built from a half-arrived response carries no
// Production Group, which would open the chart on a Section that momentarily looks as though it has
// never had one.
const linkedSections = computed<Section[]>(() => (linkedSection.value === null || isLinkedLiveKpisLoading.value || isLinkedProductionGroupsLoading.value ? [] : [linkedSection.value]));

// The same two-pass row build the grid uses, over the single linked Section - so the overlay and
// the header it shares with the KPI modals receive exactly the row shape they already expect.
const { sectionRows: linkedSectionRows } = useSectionRows(linkedSections, linkedProductionGroupBySectionId, linkedLiveKpisBySectionId, farmsById, barnsById);

// The row the overlay renders: the grid's own where the filters show it, the independently resolved
// one otherwise. Null while either source is still loading, and null for good when the id names no
// Section this user can see - in both cases the grid simply shows through, which is also what a
// hand-edited id should do.
const selectedSection = computed<SectionRow | null>(() => openSectionGridRow.value ?? linkedSectionRows.value[0] ?? null);

// How far back the open Section's own Production Group history is read for the comparison dropdown.
// Wide enough to contain the cycle before the one on screen for every animal group this page covers,
// and no wider - the dropdown offers the immediately preceding period, not a historical archive.
const comparisonHistoryRequest = computed<ProductionGroupTimelineRequest | null>(() => {
    const section = selectedSection.value;
    if (section === null) return null;
    const anchor = section.productionGroupStart === null ? new Date() : parseISO(section.productionGroupStart);
    return {
        sectionId: section.id,
        barnId: section.barnId,
        from: format(subMonths(anchor, COMPARISON_HISTORY_MONTHS), 'yyyy-MM-dd'),
        to: format(new Date(), 'yyyy-MM-dd'),
    };
});

// `isError` is carried, not swallowed. An empty history and a history that failed to load look
// identical downstream, and the comparison dropdown's empty state reads "no earlier group to compare
// against" - a statement about the Section, made on the strength of a request that never arrived.
const { data: comparisonHistoryData, isError: isComparisonHistoryError } = useProductionGroupTimeline(comparisonHistoryRequest);
const selectedSectionProductionGroupHistory = computed<ProductionGroup[]>(() => comparisonHistoryData.value ?? []);

// Keep the live overview legible: a refresh spins the shared refresh glyph, and any row whose
// displayed live values changed receives a short, non-blocking highlight. The signature excludes
// UI-only state (sort/order/modal state) so selection changes cannot look like new telemetry.
//
// Highlighting is driven by `sectionRows` itself rather than by whatever triggered the refetch, so
// the manual refresh button, the 5-minute background poll, and a Production Group save all go through
// the same path — none of them has to know about highlighting. A change made while the Manage
// Production Group modal is open is queued and revealed only once the modal closes, so the user
// doesn't miss the flash behind the overlay.
const changedSectionIds = ref(new Set<number>());
const highlightTimers = new Map<number, ReturnType<typeof setTimeout>>();
const pendingHighlightIds = new Set<number>();

function rowSignature(section: SectionRow): string {
    return JSON.stringify({
        hasProductionGroup: section.hasProductionGroup,
        pigCount: section.pigCount,
        latestWeightKg: section.latestWeightKg,
        dailyGain: section.dailyGain,
        liveGrowthIndex: section.liveGrowthIndex,
        waterIndex: section.waterIndex,
        mortalityPercent: section.mortalityPercent,
        mortalityCumulativePercent: section.mortalityCumulativePercent,
    });
}

function highlightSection(sectionId: number): void {
    const timer = highlightTimers.get(sectionId);
    if (timer) clearTimeout(timer);

    changedSectionIds.value = new Set(changedSectionIds.value).add(sectionId);
    highlightTimers.set(
        sectionId,
        setTimeout(() => {
            const next = new Set(changedSectionIds.value);
            next.delete(sectionId);
            changedSectionIds.value = next;
            highlightTimers.delete(sectionId);
        }, 1600)
    );
}

const isRefreshing = computed(() => isLiveKpisFetching.value || isBarnKpisFetching.value);

function refreshOverview(): Promise<[unknown, unknown]> {
    return Promise.all([refetchLiveKpis(), refetchBarnKpis()]);
}

// Fires on every `sectionRows` recompute, whatever caused it — a manual refresh, the background
// poll, or a Production Group write invalidating the same queries from inside the modal. Diffs against
// our own last-stable snapshot rather than Vue's built-in previous value: `physicalSections`,
// `useBarnProductionGroups` and `useSectionLiveKpis` settle at different times during initial load, so
// whichever resolves last flips `isLoading` to false in the very same tick it supplies real data —
// diffing against Vue's raw previous tick (still the partial/null pre-load rows) would flash the
// whole table the instant the spinner disappears. Clearing the snapshot while loading means that
// first real tick has no baseline to compare against, so nothing highlights.
let lastStableRows: SectionRow[] | null = null;
watch(sectionRows, (rows) => {
    if (isLoading.value) {
        lastStableRows = null;
        return;
    }

    const previousById = new Map((lastStableRows ?? []).map((row) => [row.id, row]));
    const changedIds = rows
        .filter((row) => {
            const previous = previousById.get(row.id);
            return previous !== undefined && rowSignature(previous) !== rowSignature(row);
        })
        .map((row) => row.id);

    if (isManageModalOpen.value) changedIds.forEach((id) => pendingHighlightIds.add(id));
    else changedIds.forEach((id) => highlightSection(id));

    lastStableRows = rows;
});

watch(isManageModalOpen, (isOpen) => {
    if (isOpen) return;
    pendingHighlightIds.forEach((id) => highlightSection(id));
    pendingHighlightIds.clear();
});

// Timers outlive the row they're animating only by design (1.6s) — but not the component itself.
onUnmounted(() => {
    highlightTimers.forEach((timer) => clearTimeout(timer));
    highlightTimers.clear();
});

// Farm → Barn → Section grouping, sorted within each Barn by the selected sort key (Module B/G).
const farmGroups = computed(() => sortAndGroupSectionsByFarm(sectionRows.value, sortKey.value));

// The rows whose Døde cell can open the mortality detail modal (same guard as the cell's button),
// flattened from the grouped/sorted structure above so prev/next follows the rendered order.
const mortalityDetailSections = computed<SectionRow[]>(() =>
    farmGroups.value.flatMap((farm) =>
        farm.barns.flatMap((barn) => barn.sections.filter((section) => section.hasProductionGroup))
    )
);

// The rows whose Water Norm cell can open the detail modal (same guard as the cell's button),
// flattened from the grouped/sorted structure above so prev/next follows the rendered order.
const waterDetailSections = computed<SectionRow[]>(() =>
    farmGroups.value.flatMap((farm) =>
        farm.barns.flatMap((barn) => barn.sections.filter((section) => section.hasProductionGroup && section.hasWaterSensor))
    )
);

// The rows whose Vægt/Tilvækst/Vækstindeks cells can open the weight detail modal (same guard as
// the cells' buttons — hasWeightSensor, not a per-value check, since each headline card in the
// modal handles its own null state), flattened from the grouped/sorted structure above so
// prev/next follows the rendered order.
const weightDetailSections = computed<SectionRow[]>(() =>
    farmGroups.value.flatMap((farm) =>
        farm.barns.flatMap((barn) => barn.sections.filter((section) => section.hasWeightSensor))
    )
);

// The rows whose chart icon can open the fullscreen detail overlay - unguarded, unlike the KPI
// detail lists above, since the chart affordance stays visible for every Section - flattened from
// the grouped/sorted structure above so prev/next follows the rendered order.
const allDetailSections = computed<SectionRow[]>(() =>
    farmGroups.value.flatMap((farm) => farm.barns.flatMap((barn) => barn.sections))
);

// Card classes for a Section row. Three visually distinct states:
//   - Inactive (no Production Group): dashed outer border, #FBFBFC bg — physically exists, not being monitored.
//   - Ghost (Production Group active, no pigs): dashed outer border, white bg — monitored, but empty.
//   - Active: solid outer border + attention-coloured 4px left border, hover shadow. The row itself
//     is not clickable — the chart icon at the row end opens the detail overlay.
function cardClasses(section: SectionRow): string {
    if (!section.hasProductionGroup) {
        return 'border-dashed border-gray-200 border-l-gray-200 bg-[#FBFBFC]';
    }
    if (section.isEmpty) {
        return 'border-dashed border-gray-200 border-l-gray-200 bg-white';
    }
    const hover = 'hover:shadow-[0_2px_8px_rgba(16,24,40,0.08)]';
    // `attentionLevel` is precomputed per row by useSectionRows (Module A) - read directly here
    // rather than recomputed. An active Alarm is the only signal that lights a card.
    if (section.attentionLevel === 'red') {
        // Pink outer border + deep red left border + warm off-white background.
        return `border-[#F1B5B0] border-l-[#DC2626] bg-[#FFFBFA] ${hover}`;
    }
    // Subtle gray left border signals card identity without demanding attention.
    return `border-gray-200 border-l-[#D8DDE3] bg-white ${hover}`;
}

// Dynamic Mortality colouring: red at or above the mortality target, green below, neutral
// (no colour, same convention as the index columns' `indexColourClass`) when the target
// comparison itself is unknown/uncalculated - that must not silently read as "all good".
function mortalityPercentClass(atOrAboveTarget: boolean | null): string {
    if (atOrAboveTarget === null) return INDEX_COLOUR_NEUTRAL;
    return atOrAboveTarget ? INDEX_COLOUR_RED : INDEX_COLOUR_GREEN;
}

// The mortality figure + threshold flag for the row under the active page-level view (rolling vs
// cumulative). Both are computed once per cell so the template reads a single consistent view.
function sectionMortalityPercent(section: SectionRow): number | null {
    return mortalityPercentForView(section, mortalityView.value);
}

function sectionMortalityAtOrAboveTarget(section: SectionRow): boolean | null {
    return mortalityAtOrAboveTargetForView(section, mortalityView.value);
}

function sectionMortalityPigsToTarget(section: SectionRow): number | null {
    return mortalityPigsToTargetForView(section, mortalityView.value);
}

// The barn aggregate strip's dead count under the active page-level mortality view — same toggle as
// the Døde column (mortalityView), so the two figures always agree on which window they show.
function barnDeadCount(barnId: number): number | null {
    const kpi = barnKpiByBarnId.value.get(barnId);
    if (!kpi) return null;
    return mortalityView.value === 'cumulative' ? kpi.dead_count_since_start : kpi.dead_count_last_7_days;
}

// How many of the barn's sections are missing from the dead count above. The barn's pig count covers
// every section (and every section now shows its own), so only Dead needs the caveat.
function barnSectionsSuppressed(barnId: number): number {
    return barnKpiByBarnId.value.get(barnId)?.sections_suppressed ?? 0;
}

// The graph affordance stays visible for every Section. The stream itself owns the empty state when
// a Section has not started a Production Group or has no readings yet.
function openSection(section: SectionRow) {
    router.push({ name: 'ActiveGroupsDetail', params: { sectionId: String(section.id) } });
}

// Closing returns to the grid's own route. Stepping back unwinds the entry that opened the overlay,
// so Back after closing leaves the page instead of walking straight into the Section again — but the
// overlay can also be arrived at directly from a shared link, where there is no grid behind it to
// step back to, so that case pushes the grid instead.
// Settles only once the navigation has, so a caller that opens something else afterwards is not
// mounting it underneath an overlay still on screen. `router.back()` is `history.go(-1)`: it hands
// back nothing and completes when the browser fires `popstate`, so that branch waits a tick rather
// than on a promise the router does not offer.
async function closeSection(): Promise<void> {
    const previous = window.history.state?.back;
    const gridPath = router.resolve({ name: 'ActiveGroups' }).path;
    if (typeof previous === 'string' && previous.split('?')[0] === gridPath) {
        router.back();
        await nextTick();
        return;
    }
    await router.push({ name: 'ActiveGroups' });
}

// Prev/next inside the overlay replaces rather than pushes: stepping through a barn's Sections is
// browsing one view, not visiting a series of pages, and pushing each one would bury the page the
// user came from under however many Sections they stepped past.
function navigateToSection(section: SectionRow) {
    router.replace({ name: 'ActiveGroupsDetail', params: { sectionId: String(section.id) }, query: route.query });
}

// Alarm handling from inside the mortality detail modal. The multi-alarm list modal sits at the same
// z-index (1030) as the mortality modal and would paint underneath it, so the mortality modal closes
// before the alarm flow opens.
function openAlarmFromMortalityDetail(section: SectionRow, openAlarmModal: CallableFunction) {
    mortalityDetailSection.value = null;
    openAlarm(section, openAlarmModal);
}

// Alarm handling from inside the water detail modal — same z-index handoff as the mortality modal.
function openAlarmFromWaterDetail(section: SectionRow, openAlarmModal: CallableFunction) {
    waterDetailSection.value = null;
    openAlarm(section, openAlarmModal);
}

// Alarm handling from inside the weight detail modal — same z-index handoff as the mortality modal.
function openAlarmFromWeightDetail(section: SectionRow, openAlarmModal: CallableFunction) {
    weightDetailSection.value = null;
    openAlarm(section, openAlarmModal);
}

// Alarm handling from inside the fullscreen section detail overlay — same z-index handoff as the
// other detail views, except that this one closes by navigating. The alarm list modal sits below the
// overlay, so it is opened only once the overlay has gone rather than in the same tick.
async function openAlarmFromSectionDetail(section: SectionRow, openAlarmModal: CallableFunction) {
    await closeSection();
    openAlarm(section, openAlarmModal);
}

// Open the manage Production Group modal for a row. Available on every row regardless of state; the modal
// picks create vs edit mode from the row's `productionGroupId`. Click handler in the template stops
// propagation so the row's own `openSection` does not also fire.
function openManageProductionGroup(section: SectionRow) {
    manageRow.value = section;
    manageProductionGroup.value = productionGroupBySectionId.value.get(section.id) ?? null;
    isManageModalOpen.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    heading: _ctx.$t('views.monitoring.activeGroups.headings.title'),
    "has-pig-type-picker": "",
    "slim-pig-type-picker": ""
  }, {
    "header-top-right": _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-default disabled:opacity-50",
        disabled: isRefreshing.value,
        title: _ctx.$t('views.monitoring.activeGroups.texts.refresh'),
        onClick: refreshOverview
      }, [
        _createVNode(_unref(RefreshCw), {
          class: _normalizeClass(["h-4 w-4", { 'animate-spin': isRefreshing.value }]),
          "aria-hidden": "true"
        }, null, 8, ["class"]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.refresh')), 1)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "border-t border-t-gray-200 mt-5 mb-6",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.fields.farm')) + ":", 1),
          _createVNode(FarmChipPicker, {
            farms: validFarms.value,
            modelValue: selectedFarmIds.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFarmIds).value = $event))
          }, null, 8, ["farms", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.mortalityView.label')) + ":", 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mortalityViewOptions, (option) => {
              return _createElementVNode("button", {
                key: option,
                type: "button",
                class: _normalizeClass(["rounded-md px-3 py-1.5 text-sm font-medium transition-colors", mortalityView.value === option ? 'bg-primary-700 text-white' : 'text-gray-600 hover:bg-gray-100']),
                onClick: ($event: any) => (mortalityView.value = option)
              }, _toDisplayString(_ctx.$t(`views.monitoring.activeGroups.mortalityView.${option}`)), 11, _hoisted_8)
            }), 64))
          ])
        ]),
        _createElementVNode("div", {
          class: "flex items-center gap-2",
          title: _ctx.$t('views.monitoring.activeGroups.sort.tierHint')
        }, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.fields.sort')) + ":", 1),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
              return _createElementVNode("button", {
                key: option,
                type: "button",
                class: _normalizeClass(["rounded-md px-3 py-1.5 text-sm font-medium transition-colors", sortKey.value === option ? 'bg-primary-700 text-white' : 'text-gray-600 hover:bg-gray-100']),
                onClick: ($event: any) => (sortKey.value = option)
              }, _toDisplayString(_ctx.$t(`views.monitoring.activeGroups.sort.${option}`)), 11, _hoisted_12)
            }), 64))
          ])
        ], 8, _hoisted_9)
      ]),
      _createVNode(ActionModal, {
        "initial-step-index": 1,
        "initial-state": _unref(alarmActionState),
        "step-config": _unref(alarmStepConfig),
        header: _unref(alarmActionHeader),
        onClosing: _unref(onAlarmFormClosing)
      }, {
        default: _withCtx(({ open: openAlarmModal }) => [
          _createVNode(FadeTransition, { mode: "out-in" }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(Spinner, { class: "h-10 w-10" })
                  ]))
                : (farmGroups.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(farmGroups.value, (farm, farmIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: farm.farmId,
                            class: _normalizeClass(farmIndex > 0 ? 'mt-8 border-t-2 border-gray-200 pt-5' : '')
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(farm.barns, (barn) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `${farm.farmId}-${barn.barnName}`,
                                class: "mb-5 last:mb-0"
                              }, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(farm.farmName) + " · " + _toDisplayString(barn.barnName), 1),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$tc('views.monitoring.activeGroups.tables.sections', barn.sections.length)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.barnAggregate.pigs')), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["font-semibold tabular-nums", barnKpiByBarnId.value.get(barn.barnId)?.pig_count != null ? 'text-gray-600' : 'text-gray-300'])
                                    }, _toDisplayString(barnKpiByBarnId.value.get(barn.barnId)?.pig_count != null ? _ctx.$n(barnKpiByBarnId.value.get(barn.barnId)!.pig_count!, 'decimal') : placeholder), 3)
                                  ]),
                                  _createElementVNode("span", _hoisted_22, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.barnAggregate.dead')), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["font-semibold tabular-nums", barnDeadCount(barn.barnId) != null ? 'text-gray-600' : 'text-gray-300'])
                                    }, _toDisplayString(barnDeadCount(barn.barnId) != null ? _ctx.$n(barnDeadCount(barn.barnId)!, 'decimal') : placeholder), 3),
                                    (barnSectionsSuppressed(barn.barnId) > 0)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cursor-help italic text-gray-300",
                                          title: _ctx.$t('views.monitoring.activeGroups.barnAggregate.deadPartialTooltip')
                                        }, _toDisplayString(_ctx.$tc('views.monitoring.activeGroups.barnAggregate.deadPartial', barnSectionsSuppressed(barn.barnId))), 9, _hoisted_24))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.section')), 1),
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.age')), 1),
                                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.weight')), 1),
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.pigs')), 1),
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.dead')), 1),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.dailyGain')), 1),
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.growthIndex')), 1),
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.tables.headings.waterIndex')), 1),
                                  _cache[9] || (_cache[9] = _createElementVNode("div", { "aria-hidden": "true" }, null, -1))
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(barn.sections, (section) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: section.id,
                                      class: _normalizeClass(["section-grid-row items-center rounded-[9px] border border-l-4 text-sm transition-shadow duration-150", [cardClasses(section), { 'section-recently-updated': changedSectionIds.value.has(section.id) }]])
                                    }, [
                                      (section.hasProductionGroup)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-[9px] text-left transition-colors hover:bg-gray-200",
                                            title: _ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.editTitle'),
                                            "aria-label": `${_ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.editTitle')}: ${section.sectionName}`,
                                            onClick: _withModifiers(($event: any) => (openManageProductionGroup(section)), ["stop"])
                                          }, [
                                            _createElementVNode("span", {
                                              class: "min-w-0 flex-1 truncate",
                                              title: section.productionGroupName ? `${section.sectionName} · ${section.productionGroupName}` : section.sectionName
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["text-[13.5px] font-semibold", !section.isEmpty ? 'text-gray-900' : 'text-gray-400'])
                                              }, _toDisplayString(section.sectionName), 3),
                                              (section.productionGroupName)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " · " + _toDisplayString(section.productionGroupName), 1))
                                                : _createCommentVNode("", true)
                                            ], 8, _hoisted_36)
                                          ], 8, _hoisted_35))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            _createElementVNode("span", {
                                              class: "min-w-0 flex-1 truncate text-[13.5px] font-semibold text-gray-400",
                                              title: section.sectionName
                                            }, _toDisplayString(section.sectionName), 9, _hoisted_39)
                                          ])),
                                      (!section.hasProductionGroup)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("div", _hoisted_40, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "inline-flex shrink-0 items-center gap-1.5 rounded-full border border-primary-600 bg-primary-50 px-3 py-1 text-[11.5px] font-bold text-primary-700 transition-colors hover:bg-primary-100",
                                                title: _ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.createTitle'),
                                                onClick: _withModifiers(($event: any) => (openManageProductionGroup(section)), ["stop"])
                                              }, [
                                                _createVNode(_unref(PlayCircle), {
                                                  class: "h-3.5 w-3.5 shrink-0",
                                                  "aria-hidden": "true"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.createTitle')), 1)
                                              ], 8, _hoisted_41)
                                            ]),
                                            _createElementVNode("div", _hoisted_42, _toDisplayString(section.pigCount != null ? _ctx.$n(section.pigCount, 'decimal') : placeholder), 1),
                                            _createElementVNode("div", _hoisted_43, [
                                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.noProductionGroup')), 1)
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createElementVNode("div", _hoisted_45, [
                                              (section.activeAlarms.length > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: _normalizeClass(_unref(ALARM_CHIP_CLASS)),
                                                    onClick: _withModifiers(($event: any) => (_unref(openAlarm)(section, openAlarmModal)), ["stop"])
                                                  }, [
                                                    _createVNode(_unref(AlertTriangle), {
                                                      class: "h-3 w-3 shrink-0",
                                                      "aria-hidden": "true"
                                                    }),
                                                    (section.day !== null)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.week')) + " " + _toDisplayString(section.week) + " · " + _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.day')) + " " + _toDisplayString(section.day), 1)
                                                        ], 64))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_unref(ChevronRight), {
                                                      class: "h-3 w-3 shrink-0",
                                                      "aria-hidden": "true"
                                                    })
                                                  ], 10, _hoisted_46))
                                                : (section.day !== null)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.week')) + " " + _toDisplayString(section.week) + " · " + _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.day')) + " " + _toDisplayString(section.day), 1))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(placeholder)))
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                              _createVNode(SensorGatedKpiCell, {
                                                "has-sensor": section.hasWeightSensor,
                                                "has-value": section.latestWeightKg !== null,
                                                "open-title": _ctx.$t('views.monitoring.activeGroups.modals.weightDetail.openTitle'),
                                                "button-class": "flex items-baseline gap-1",
                                                onOpen: ($event: any) => (weightDetailSection.value = section)
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["text-[16px] font-extrabold leading-none", section.weightSource === 'Estimated' ? 'text-[#8C96A3]' : 'text-gray-900'])
                                                  }, _toDisplayString(_ctx.$n(section.latestWeightKg!, 'weight')), 3),
                                                  _createElementVNode("small", {
                                                    class: _normalizeClass(["text-[11px]", section.weightSource === 'Estimated' ? 'text-[#B6BEC9]' : 'text-gray-400'])
                                                  }, _toDisplayString(section.weightSource === 'Estimated' ? 'kg · est.' : 'kg'), 3),
                                                  _createVNode(DegradedCameraMarker, {
                                                    contributing: section.contributingWeightCameraCount,
                                                    expected: section.expectedCameraCount
                                                  }, null, 8, ["contributing", "expected"])
                                                ]),
                                                _: 2
                                              }, 1032, ["has-sensor", "has-value", "open-title", "onOpen"])
                                            ]),
                                            _createElementVNode("div", _hoisted_50, _toDisplayString(section.pigCount != null ? _ctx.$n(section.pigCount, 'decimal') : placeholder), 1),
                                            _createElementVNode("div", _hoisted_51, [
                                              (section.hasProductionGroup)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "flex w-full items-baseline gap-0.5 rounded-md px-3 py-[9px] transition-colors hover:bg-gray-200",
                                                    title: _ctx.$t('views.monitoring.activeGroups.modals.mortalityDetail.openTitle'),
                                                    onClick: ($event: any) => (mortalityDetailSection.value = section)
                                                  }, [
                                                    (sectionMortalityPercent(section) !== null)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(["text-[16px] font-extrabold leading-none", mortalityPercentClass(sectionMortalityAtOrAboveTarget(section))])
                                                          }, _toDisplayString(_ctx.$n(sectionMortalityPercent(section)!, 'decimal')), 3),
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(["text-[12.5px] font-medium", mortalityPercentClass(sectionMortalityAtOrAboveTarget(section))])
                                                          }, "%", 2),
                                                          (sectionMortalityPigsToTarget(section) !== null)
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                key: 0,
                                                                class: _normalizeClass(["text-[10.5px] font-semibold", _unref(pigsToTargetColourClass)(sectionMortalityPigsToTarget(section))])
                                                              }, "(" + _toDisplayString(_unref(formatPigsToTarget)(sectionMortalityPigsToTarget(section)!)) + ")", 3))
                                                            : _createCommentVNode("", true)
                                                        ], 64))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(placeholder)))
                                                  ], 8, _hoisted_52))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(placeholder)))
                                            ]),
                                            _createElementVNode("div", _hoisted_55, [
                                              _createVNode(SensorGatedKpiCell, {
                                                "has-sensor": section.hasWeightSensor,
                                                "has-value": section.dailyGain !== null,
                                                "open-title": _ctx.$t('views.monitoring.activeGroups.modals.weightDetail.openTitle'),
                                                "button-class": "flex items-baseline gap-1",
                                                onOpen: ($event: any) => (weightDetailSection.value = section)
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$n(section.dailyGain!, 'decimal')), 1),
                                                  _createElementVNode("small", _hoisted_57, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.dailyGainUnit')), 1),
                                                  _createVNode(DegradedCameraMarker, {
                                                    contributing: section.contributingDailyGainCameraCount,
                                                    expected: section.expectedCameraCount
                                                  }, null, 8, ["contributing", "expected"])
                                                ]),
                                                _: 2
                                              }, 1032, ["has-sensor", "has-value", "open-title", "onOpen"])
                                            ]),
                                            _createElementVNode("div", null, [
                                              _createVNode(SensorGatedKpiCell, {
                                                "has-sensor": section.hasWeightSensor,
                                                "has-value": section.liveGrowthIndex !== null,
                                                "open-title": _ctx.$t('views.monitoring.activeGroups.modals.weightDetail.openTitle'),
                                                "button-class": "flex items-center gap-1.5",
                                                onOpen: ($event: any) => (weightDetailSection.value = section)
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(IndexGaugeBar, {
                                                    value: section.liveGrowthIndex!
                                                  }, null, 8, ["value"]),
                                                  _createVNode(DegradedCameraMarker, {
                                                    contributing: section.contributingGrowthIndexCameraCount,
                                                    expected: section.expectedCameraCount
                                                  }, null, 8, ["contributing", "expected"])
                                                ]),
                                                _: 2
                                              }, 1032, ["has-sensor", "has-value", "open-title", "onOpen"])
                                            ]),
                                            _createElementVNode("div", null, [
                                              (!section.hasWaterSensor)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: "block px-3 py-[9px]",
                                                    title: _ctx.$t('views.monitoring.activeGroups.texts.noSensor')
                                                  }, [
                                                    _createVNode(_unref(Ban), {
                                                      class: "h-3.5 w-3.5 text-gray-300",
                                                      "aria-hidden": "true"
                                                    })
                                                  ], 8, _hoisted_58))
                                                : (section.hasProductionGroup)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      type: "button",
                                                      class: "flex w-full items-center gap-1.5 rounded-md px-3 py-[9px] transition-colors hover:bg-gray-200",
                                                      title: _ctx.$t('views.monitoring.activeGroups.modals.waterDetail.openTitle'),
                                                      onClick: ($event: any) => (waterDetailSection.value = section)
                                                    }, [
                                                      (section.waterIndex !== null)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createVNode(_unref(Droplets), {
                                                              class: "h-3.5 w-3.5 shrink-0 text-gray-400",
                                                              "aria-hidden": "true"
                                                            }),
                                                            _createVNode(IndexGaugeBar, {
                                                              value: section.waterIndex
                                                            }, null, 8, ["value"])
                                                          ], 64))
                                                        : (_openBlock(), _createBlock(_unref(WifiOff), {
                                                            key: 1,
                                                            class: "h-3.5 w-3.5 text-gray-300",
                                                            "aria-hidden": "true"
                                                          }))
                                                    ], 8, _hoisted_59))
                                                  : (_openBlock(), _createElementBlock("span", {
                                                      key: 2,
                                                      class: "block px-3 py-[9px]",
                                                      title: _ctx.$t('views.monitoring.activeGroups.texts.noData')
                                                    }, [
                                                      _createVNode(_unref(WifiOff), {
                                                        class: "h-3.5 w-3.5 text-gray-300",
                                                        "aria-hidden": "true"
                                                      })
                                                    ], 8, _hoisted_60))
                                            ])
                                          ], 64)),
                                      _createElementVNode("div", _hoisted_61, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "grid h-7 w-7 shrink-0 place-content-center rounded-md border border-gray-200 bg-white text-gray-400 transition-colors hover:border-gray-300 hover:bg-gray-50 hover:text-gray-600",
                                          title: _ctx.$t('views.monitoring.activeGroups.texts.openChart'),
                                          onClick: ($event: any) => (openSection(section))
                                        }, [
                                          _createVNode(_unref(LineChart), {
                                            class: "h-4 w-4",
                                            "aria-hidden": "true"
                                          })
                                        ], 8, _hoisted_62)
                                      ])
                                    ], 2))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.texts.noSections')), 1)
                    ]))
            ]),
            _: 2
          }, 1024),
          _createVNode(AlarmHandleModal, {
            open: _unref(alarmListModalOpen),
            alarms: _unref(alarmListAlarms),
            "is-loading": _unref(isLoadingAlarmForm),
            onClose: _cache[1] || (_cache[1] = ($event: any) => (alarmListModalOpen.value = false)),
            onSelectAlarm: (id) => _unref(loadAndOpenAlarm)(id, openAlarmModal)
          }, null, 8, ["open", "alarms", "is-loading", "onSelectAlarm"]),
          _createVNode(MortalityDetailModal, {
            section: mortalityDetailSection.value,
            sections: mortalityDetailSections.value,
            view: mortalityView.value,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (mortalityDetailSection.value = null)),
            onNavigate: _cache[3] || (_cache[3] = ($event: any) => (mortalityDetailSection.value = $event)),
            onHandleAlarm: (section) => openAlarmFromMortalityDetail(section, openAlarmModal),
            onEditTarget: onEditTargetFromMortalityDetail
          }, null, 8, ["section", "sections", "view", "onHandleAlarm"]),
          _createVNode(WaterDetailModal, {
            section: waterDetailSection.value,
            sections: waterDetailSections.value,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (waterDetailSection.value = null)),
            onNavigate: _cache[5] || (_cache[5] = ($event: any) => (waterDetailSection.value = $event)),
            onHandleAlarm: (section) => openAlarmFromWaterDetail(section, openAlarmModal)
          }, null, 8, ["section", "sections", "onHandleAlarm"]),
          _createVNode(WeightDetailModal, {
            section: weightDetailSection.value,
            sections: weightDetailSections.value,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (weightDetailSection.value = null)),
            onNavigate: _cache[7] || (_cache[7] = ($event: any) => (weightDetailSection.value = $event)),
            onHandleAlarm: (section) => openAlarmFromWeightDetail(section, openAlarmModal)
          }, null, 8, ["section", "sections", "onHandleAlarm"]),
          _createVNode(SectionDetailOverlay, {
            section: selectedSection.value,
            sections: allDetailSections.value,
            "production-group-history": selectedSectionProductionGroupHistory.value,
            "production-group-history-unavailable": _unref(isComparisonHistoryError),
            onClose: closeSection,
            onNavigate: navigateToSection,
            onHandleAlarm: (section) => openAlarmFromSectionDetail(section, openAlarmModal)
          }, null, 8, ["section", "sections", "production-group-history", "production-group-history-unavailable", "onHandleAlarm"])
        ]),
        _: 1
      }, 8, ["initial-state", "step-config", "header", "onClosing"]),
      _createVNode(ManageProductionGroupModal, {
        modelValue: isManageModalOpen.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isManageModalOpen).value = $event)),
        target: manageRow.value,
        "production-group": manageProductionGroup.value,
        "extra-invalidate-query-key-roots": manageModalInvalidateQueryKeyRoots
      }, null, 8, ["modelValue", "target", "production-group"]),
      _createVNode(ManageObjectivesModal, {
        ref_key: "targetsModal",
        ref: targetsModal,
        "is-weaner": isWeaners.value,
        "show-trigger": false,
        onSaved: onTargetSaved
      }, null, 8, ["is-weaner"])
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})